export default {
    name: "events-posts",
    template: '#vue-events-posts',

    data() {
        return {
            isLoaded: false,
        }
    },

    props: {
        posts: Array,
    },

    mounted() {
        this.isLoaded = true;
    },

    methods: {
        printDate(d) {
            const initDate = d.split('-'),
                currentDate = new Date(initDate[2], initDate[1] - 1, initDate[0]),
                day = new Intl.DateTimeFormat('en', {
                    day: 'numeric'
                }).format(currentDate),
                month = new Intl.DateTimeFormat('en', {
                    month: 'short'
                }).format(currentDate);

            return `${day} ${month}`;
        },

        printYearDate(d) {
            const initDate = d.split('-'),
                currentDate = new Date(initDate[2], initDate[1] - 1, initDate[0]),
                day = new Intl.DateTimeFormat('en', {
                    day: 'numeric'
                }).format(currentDate),
                month = new Intl.DateTimeFormat('en', {
                    month: 'short'
                }).format(currentDate),
                year = new Intl.DateTimeFormat('en', {
                    year: 'numeric'
                }).format(currentDate);

            return `${day} ${month}<br class="hidden | lg:inline">${year}`;
        }
    },
}